export const SCREEN_READER_ANNOUNCER_ID = 'screen-reader-announcer';

export const updateA11yAnnouncement = (message: string) => {
  const announcer = document.getElementById(SCREEN_READER_ANNOUNCER_ID);
  if (announcer) {
    announcer.innerText = message;
  }
};
